import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/home'
import Signup from './components/signup'
import Signin from './components/signin'
import SigninRequest from './components/signin-request'
import BrwDocumentos from './components/brw-documentos'
import VerDocumento from './components/ver-documento-propio'
import BrwNotificaciones from './components/brw-notificaciones'
import VerExtracto from './components/ver-extracto'
import BrwLiquidaciones from './components/brw-liquidaciones'
import BrwResumenLiquidacion from './components/brw-resumen-liquidacion'
import BrwDetalleLiquidacion from './components/brw-detalle-liquidacion'
import BrwIncidencias from './components/brw-incidencias'
import BrwCuestionarios from './components/brw-cuestionarios'
import Cuestionario from './components/cuestionario'
import VerFacturaLiquidacion from './components/ver-factura-liquidacion-propio'

import store from './store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

export default new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/login/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/login/signin',
      name: 'Signin',
      component: Signin,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/login/signin/:token',
      name: 'SigninRequest',
      component: SigninRequest,
      beforeEnter: ifNotAuthenticated,
      props: true
    },
    {
      path: '/documentos/:carpeta',
      component: BrwDocumentos,
      beforeEnter: ifAuthenticated,
      props: true
    },
    {
      path: '/documentos/:carpeta/:idDocumento',
      component: VerDocumento,
      beforeEnter: ifAuthenticated,
      props: (route) => ({ 
          carpeta: route.params.carpeta,
          idDocumento: parseInt(route.params.idDocumento) })
    },
    {
      path: '/notificaciones',
      component: BrwNotificaciones,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/extracto',
      component: VerExtracto,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/liquidaciones',
      component: BrwLiquidaciones,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/liquidaciones/:idLiquidacion/resumen',
      component: BrwResumenLiquidacion,
      beforeEnter: ifAuthenticated,
      props: (route) => ({ idLiquidacion: parseInt(route.params.idLiquidacion) })
    },
    {
      path: '/liquidaciones/:idLiquidacion/detalle/:idTipoGastoIngreso',
      component: BrwDetalleLiquidacion,
      beforeEnter: ifAuthenticated,
      props: (route) => ({ 
        idLiquidacion: parseInt(route.params.idLiquidacion),
        idTipoGastoIngreso: parseInt(route.params.idTipoGastoIngreso)
       })
    },
    {
      path: '/liquidaciones/:idLiquidacion/detalle/:idDetalle/documento/:idDocumento',
      component: VerFacturaLiquidacion,
      beforeEnter: ifAuthenticated,
      props: (route) => ({ 
        idLiquidacion: parseInt(route.params.idLiquidacion),
        idDetalle: parseInt(route.params.idDetalle),
        idDocumento: parseInt(route.params.idDocumento)
       })
    },
    {
      path: '/incidencias',
      component: BrwIncidencias,
      beforeEnter: ifAuthenticated,
      props: true
    },
    {
      path: '/cuestionarios',
      component: BrwCuestionarios,
      beforeEnter: ifAuthenticated,
      props: true
    },
    {
      path: '/cuestionario/:idCuestionario',
      component: Cuestionario,
      beforeEnter: ifAuthenticated,
      props: (route) => ({ 
        idCuestionario: parseInt(route.params.idCuestionario)
       })
    }
  ],
})
